import React, { useState, useEffect, useContext } from 'react';
import { Card, Form, Row, Col, InputGroup, Button, Spinner } from 'react-bootstrap';
import { FaDollarSign, FaPercent, FaPercentage } from 'react-icons/fa';
import servicosService from '../../api/servicosService';
import { NotificationContext } from '../../contexts/notification-context';
import { useAuth } from '../../contexts/auth-context';

const ConfiguracaoServicos = () => {
    const { user } = useAuth();
    const { addNotification } = useContext(NotificationContext);
    const [servicos, setServicos] = useState([]); 
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchValores = async () => {
            setLoading(true);
            try {
                const response = await servicosService.listar();
                setServicos(response); 
            } catch (err) {
                console.error('Erro ao buscar valores dos serviços', err);
                addNotification('danger', 'Erro ao carregar valores dos serviços.');
            } finally {
                setLoading(false);
            }
        };
        fetchValores();
    }, []);

    const handleChange = (e, id, field) => {
        const { value } = e.target;
        setServicos(prev => prev.map(servico =>
            servico.id === id ? { ...servico, [field]: value } : servico
        ));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const payload = servicos.map(servico => ({
                id: servico.id,
                nome: servico.nome,
                valor: servico.valor,
                comissaoProfissional: servico.comissaoProfissional,
                UsuarioAlteracaoId: user.id 
            }));   

            await servicosService.atualizarLote(payload);
            addNotification('success', 'Valores atualizados com sucesso!');
        } catch (err) {
            console.error('Erro ao atualizar valores:', err);
            addNotification('danger', 'Erro ao atualizar valores dos serviços.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="configuracao-servicos-container">
            <Card className="shadow-sm">
                <Card.Body>
                    <Card.Title className="text-center mb-4">Configuração de Valores dos Serviços</Card.Title>
                    <hr />
                    <Row>
                        <Col md={4} sm={12}>
                            <Form.Label className="fw-bold">Serviço</Form.Label>
                        </Col>
                        <Col md={4} sm={12}>
                            <Form.Label className="fw-bold">Valor(R$)</Form.Label>
                        </Col>
                        <Col md={4} sm={12}>
                            <Form.Label className="fw-bold">Comissão Profissional(%)</Form.Label>
                        </Col>
                    </Row>
                    <Form onSubmit={handleSubmit}>
                        {loading ? <Spinner animation="border" /> : (
                            <>
                                {servicos.length > 0 ? servicos.map(servico => (
                                    <Row key={servico.id} className="mb-3 align-items-center">
                                        <Col md={4} sm={12}>
                                            <Form.Label className="fw">{servico.nome}</Form.Label>
                                        </Col>
                                        <Col md={4} sm={12}>
                                            <InputGroup>
                                                <InputGroup.Text>
                                                    <FaDollarSign />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    name={`valor-${servico.id}`}
                                                    value={servico.valor || ''}
                                                    onChange={(e) => handleChange(e, servico.id, 'valor')}
                                                    required
                                                />
                                            </InputGroup>
                                        </Col>
                                        <Col md={4} sm={12}>
                                            <InputGroup>
                                                <InputGroup.Text>
                                                    <FaPercent />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    name={`comissao-${servico.id}`}
                                                    value={servico.comissaoProfissional || ''}
                                                    onChange={(e) => handleChange(e, servico.id, 'comissaoProfissional')}
                                                    required
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                )) : <p className="text-center">Nenhum serviço encontrado.</p>}
                                <div className="d-flex justify-content-end">
                                    <Button type="submit" variant="primary" disabled={loading}>
                                        {loading ? 'Salvando...' : 'Salvar'}
                                    </Button>
                                </div>
                            </>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default ConfiguracaoServicos;
